import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

function SignOutPage() {
  return (
    <div className="flex flex-col items-center flex-auto min-w-0 sm:justify-center">
      <Paper className="flex items-center w-full min-h-full px-16 py-32 sm:w-auto sm:min-h-auto rounded-0 sm:p-48 sm:rounded-2xl sm:shadow">
        <div className="w-full mx-auto max-w-320 sm:w-320 sm:mx-0">
          <img className="w-56 mx-auto" src="assets/images/logo/logo.svg" alt="logo" />

          <Typography className="mt-32 text-4xl font-extrabold leading-tight tracking-tight text-center">
            از حساب کاربری خارج شدید
          </Typography>
        </div>
      </Paper>
    </div>
  );
}

export default SignOutPage;
